import type { ReactNode } from 'react';
import s from './kit.module.css';

export interface SegItem<K extends string> {
  key: K;
  label: ReactNode;
  /** số đếm sau nhãn (tab trạng thái) */
  n?: number;
  dot?: string;
  /** badge đỏ góc nhãn (vd số chờ duyệt) */
  badge?: number;
}

/** Nhóm nút nền xám: tab trạng thái (`role=tablist`) hoặc nút bật (mật độ Chuẩn / Gọn). */
export function Segmented<K extends string>({
  items,
  value,
  onChange,
  label,
  kind = 'tabs',
  extra,
}: {
  items: readonly SegItem<K>[];
  value: K;
  onChange: (k: K) => void;
  label: string;
  kind?: 'tabs' | 'toggle';
  /** nút chèn cuối trong cùng pill (vd "Thêm ▾") */
  extra?: ReactNode;
}) {
  const tabs = kind === 'tabs';
  return (
    <div className={s.seg} role={tabs ? 'tablist' : 'group'} aria-label={label}>
      {items.map((it) => {
        const on = it.key === value;
        return (
          <button
            key={it.key}
            type="button"
            role={tabs ? 'tab' : undefined}
            aria-selected={tabs ? on : undefined}
            aria-pressed={tabs ? undefined : on}
            className={s.segBtn}
            onClick={() => onChange(it.key)}
          >
            {it.dot && <span className={s.dot} style={{ background: it.dot }} aria-hidden="true" />}
            {it.label}
            {it.n !== undefined && <span className={s.segN}>{it.n}</span>}
            {!!it.badge && <span className={s.segBadge}>{it.badge}</span>}
          </button>
        );
      })}
      {extra}
    </div>
  );
}
